const amt_admin = require('amt_admin').default;
const app = require('angular').module('ww2_analytics.features', [amt_admin]);
const features = [
  'spies',
  'faction_campaign',
  'second_campaign',
  'campaign',
  'idle_quests',
  'player_managers',
  'story_quests',
  'weekly_quests',
  'daily_quests',
  'supply',
  'activity_rewards',
  'game_modes_usage',
  'searching_tool',
];
const templates = Object.fromEntries(
  features.map(f => [f, require(`./${f}/view.html`)])
);

function build_state(key, title) {
  return {
    url: '/' + key,
    template: templates[key],
    reloadOnSearch: false,
    data: {
      priority: 903,
      title: title,
      role: 'features',
    },
  };
}

// -- navy state config
const navy_module = require('ww2_analytics/navy_event');
const navy_state = build_state('navy', 'Navy');
navy_state.template = navy_module.template;

app.config(['$stateProvider', function ($stateProvider) {
  $stateProvider
    .state('amt.ww2.features', {
      url: '/features',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 902,
        title: 'Features',
        role: 'features',
      },
      menu: {
        glyphicon: 'flag',
        childs: [
          { state: 'amt.ww2.features.spies', glyphicon: 'flag' },
          { state: 'amt.ww2.features.faction_campaign', glyphicon: 'flag' },
          { state: 'amt.ww2.features.second_campaign', glyphicon: 'flag' },
          { state: 'amt.ww2.features.campaign', glyphicon: 'flag' },
          { state: 'amt.ww2.features.idle_quests', glyphicon: 'flag' },
          { state: 'amt.ww2.features.story_quests', glyphicon: 'flag' },
          { state: 'amt.ww2.features.weekly_quests', glyphicon: 'flag' },
          { state: 'amt.ww2.features.daily_quests', glyphicon: 'flag' },
          { state: 'amt.ww2.features.supply', glyphicon: 'flag' },
          { state: 'amt.ww2.features.activity_rewards', glyphicon: 'flag' },
          { state: 'amt.ww2.features.game_modes_usage', glyphicon: 'flag' },
          { state: 'amt.ww2.features.searching_tool', glyphicon: 'flag' },
          { state: 'amt.ww2.features.navy', glyphicon: 'flag' },
          { state: 'amt.ww2.features.player_managers', glyphicon: 'flag' },
        ],
      },
    })
    .state('amt.ww2.features.spies', build_state('spies', 'Spies'))
    .state('amt.ww2.features.faction_campaign', build_state('faction_campaign', 'Faction Campaign'))
    .state('amt.ww2.features.second_campaign', build_state('second_campaign', 'Second Campaign'))
    .state('amt.ww2.features.campaign', build_state('campaign', 'Campaign'))
    .state('amt.ww2.features.idle_quests', build_state('idle_quests', 'Idle Quests'))
    .state('amt.ww2.features.story_quests', build_state('story_quests', 'Story Quests'))
    .state('amt.ww2.features.weekly_quests', build_state('weekly_quests', 'Weekly Quests'))
    .state('amt.ww2.features.daily_quests', build_state('daily_quests', 'Daily Quests'))
    .state('amt.ww2.features.supply', build_state('supply', 'Supply'))
    .state('amt.ww2.features.activity_rewards', build_state('activity_rewards', 'Activity Rewards'))
    .state('amt.ww2.features.game_modes_usage', build_state('game_modes_usage', 'Game Modes Usage'))
    .state('amt.ww2.features.searching_tool', build_state('searching_tool', 'Searching Tool'))
    .state('amt.ww2.features.player_managers', build_state('player_managers', 'Player Managers'))
    .state('amt.ww2.features.navy', navy_state)
  },
]);

export default app.name;
